module.exports = __webpack_public_path__ + "static/media/brand-analytics.3512f4c0.svg";